import { render, staticRenderFns } from "./DownloadStatisticChart.vue?vue&type=template&id=44d7c313&scoped=true&"
import script from "./DownloadStatisticChart.vue?vue&type=script&lang=js&"
export * from "./DownloadStatisticChart.vue?vue&type=script&lang=js&"
import style0 from "./DownloadStatisticChart.vue?vue&type=style&index=0&id=44d7c313&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d7c313",
  null
  
)

export default component.exports